import { SlotPickerFallback } from '@/components/layout/oci-migration-notice/migration-schedule/fallback'
import { SlotPicker } from '@/components/layout/oci-migration-notice/migration-schedule/slot-picker'
import { COMPANY_MIGRATION_SLOTS_QUERY } from '@/components/layout/oci-migration-notice/queries'
import { QueryErrorBoundary } from '@/components/shared/error-boundary-overlay/query-error-boundary'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'

type RescheduleDialogProps = {
  idCompany: string
  waveLabel: string
  hasDate: boolean
  isOpen: boolean
  onOpenChange: (isOpen: boolean) => void
}

export const RescheduleDialog = ({
  idCompany,
  waveLabel,
  hasDate,
  isOpen,
  onOpenChange,
}: RescheduleDialogProps) => (
  <Dialog open={isOpen} onOpenChange={onOpenChange}>
    <DialogContent className="sm:max-w-lg">
      <DialogHeader>
        <DialogTitle>
          {hasDate ? 'Pick another time' : 'Pick a time'}
        </DialogTitle>
        <DialogDescription>
          Choose any free time at least 48 hours from now. We email your company
          owners and admins the new date.
        </DialogDescription>
      </DialogHeader>
      {isOpen ? (
        <QueryErrorBoundary
          queries={[COMPANY_MIGRATION_SLOTS_QUERY]}
          fallback={<SlotPickerFallback />}
        >
          <SlotPicker
            idCompany={idCompany}
            waveLabel={waveLabel}
            onRescheduled={() => onOpenChange(false)}
          />
        </QueryErrorBoundary>
      ) : null}
    </DialogContent>
  </Dialog>
)
